import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {StepAnchorDirective} from '../step-focus/step-anchor.directive';
import {currentFilledStep} from '../step-focus/step-state.model';

@Component({
    selector: 'app-step-heading',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <div class="d-flex align-items-start gap-3 mb-3">
            <span
                aria-hidden="true"
                class="step-num step-badge"
                [class.current]="state().place === 'current'"
                [class.passed]="state().place === 'passed'"
                [class.empty]="state().status === 'empty'"
                [class.invalid]="state().status === 'invalid'"></span>
            <div>
                <h3 class="fs-6 fw-bold mb-1" [class.text-danger]="state().status === 'invalid'">
                    {{ titleKey() | translate: 'online' : 'export' }}
                </h3>
                <div class="text-muted small">
                    {{ hintKey() | translate: 'online' : 'export' }}
                </div>
            </div>
        </div>
    `,
    styles: `
        :host {
            display: block;
            counter-increment: step;
        }

        .step-num::before {
            content: counter(step);
        }

        .step-num {
            font-size: 0.8125rem;
            transition:
                background-color 0.25s ease,
                border-color 0.25s ease,
                color 0.25s ease;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepHeadingComponent {
    private readonly anchor = inject(StepAnchorDirective, {optional: true});

    readonly titleKey = input.required<string>();
    readonly hintKey = input.required<string>();

    protected readonly state = computed(() => this.anchor?.state() ?? currentFilledStep);
}
